/* eslint-disable @typescript-eslint/no-explicit-any */
import axios from "axios";

export const uploadFile = async (file: File, uploadUrl: string, downloadUrl: string, parent?: any, folder?: string) => {
  const formData = new FormData();
  formData.append("file", file);
  const response = await axios
    .put(uploadUrl, formData, {
      params: {
        parent: parent,
        folder: folder,
      },
      withCredentials: true,
    })
    .catch((error) => {
      console.error(error);
    });
  if (response) {
    const uploaded = Array.isArray(response) ? response[0] : response;
    const url = downloadUrl + uploaded.data.fileID;
    return {
      key: uploaded.data.fileID,
      name: file.name,
      size: file.size,
      type: file.type,
      url: url,
    };
  }
};
